import { Button } from '@jouzen/ecom-components/v3/Button';
import { List } from '@jouzen/ecom-components/v3/List';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import slugifyString from '@/utils/slugifyString';

import Feature from './Feature';

const LearnHowButton = () => {
  const path = usePathname();
  const t = useTranslations();
  const giftSupport =
    'https://support.ouraring.com/hc/en-us/articles/360038973453-How-to-Gift-an-Oura-Ring';

  const handleAnalytics = () => {
    void window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: slugifyString(t('learn_how')),
      location: 'gift_of_better_health_module',
      module: 'gift_of_better_health_module',
      path,
    });
  };

  return (
    <Button
      href={giftSupport}
      onClick={handleAnalytics}
      variant="secondary-dark"
      className="mt-4"
    >
      {t('learn_how')}
    </Button>
  );
};

const HowGiftWorks = () => {
  const t = useTranslations();

  return (
    <section className="pt-20">
      <Feature
        title="gift_hero_title"
        body={
          <List Element="ol">
            <li key={1}>
              <div>{t('holiday_let_them_choose')}</div>
            </li>
            <li key={2}>{t('holiday_at_checkout_gift')}</li>
            <li key={3}>{t('holiday_customize_gift_message')}</li>
          </List>
        }
        button={<LearnHowButton />}
        image={{
          src: '/bf23/gift-present-feature',
          localizedAlt: 'starting_out_title',
          width: 600,
          height: 693,
        }}
      />
    </section>
  );
};

export default HowGiftWorks;
